import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/audio.svg'


const _hoisted_1 = { class: "flex items-center justify-center gap-x-2" }
const _hoisted_2 = {
  key: 1,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center gap-x-2"
}
const _hoisted_6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_7 = {
  key: 0,
  points: "5 3 19 12 5 21 5 3"
}
const _hoisted_8 = {
  key: 1,
  x: "6",
  y: "6",
  width: "12",
  height: "12"
}
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isUploadingAudio)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          class: "w-5 h-5"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.isLocalizePage || (_ctx.isLocalizePage && _ctx.audioSource))
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.inputId,
                class: "cursor-pointer"
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "audio",
                  class: "min-w-5 h-5"
                }, null, -1)
              ]), 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            id: _ctx.inputId,
            type: "file",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelection && _ctx.handleFileSelection(...args))),
            accept: "audio/wav,audio/mp3",
            class: "hidden"
          }, null, 40, _hoisted_4),
          (_ctx.audioSource)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAudio && _ctx.toggleAudio(...args)), ["prevent"])),
                  class: "p-2 bg-green-500 text-white rounded-full"
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                    (!_ctx.isPlaying)
                      ? (_openBlock(), _createElementBlock("polygon", _hoisted_7))
                      : (_openBlock(), _createElementBlock("rect", _hoisted_8))
                  ]))
                ]),
                (_ctx.audioSource)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadAudio && _ctx.downloadAudio(...args)), ["prevent"])),
                      class: ""
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("svg", {
                        width: "28",
                        height: "28",
                        viewBox: "0 0 28 28",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("circle", {
                          cx: "14",
                          cy: "14",
                          r: "14",
                          fill: "#337DD6"
                        }),
                        _createElementVNode("path", {
                          d: "M14.0001 16.4L10.0001 12.65L11.1201 11.5625L13.2001 13.5125V7.40002H14.8001V13.5125L16.8801 11.5625L18.0001 12.65L14.0001 16.4ZM9.2001 19.4C8.7601 19.4 8.38356 19.2533 8.0705 18.9598C7.75743 18.6663 7.60063 18.313 7.6001 17.9V15.65H9.2001V17.9H18.8001V15.65H20.4001V17.9C20.4001 18.3125 20.2436 18.6658 19.9305 18.9598C19.6174 19.2538 19.2406 19.4005 18.8001 19.4H9.2001Z",
                          fill: "white"
                        })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (!_ctx.isLocalizePage)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteAudio && _ctx.deleteAudio(...args)), ["prevent"])),
                      class: "p-2 bg-red-500 text-white rounded-full"
                    }, _cache[7] || (_cache[7] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "12",
                        height: "12",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                        _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("audio", {
            ref: "audioPlayer",
            src: _ctx.audioSource,
            onEnded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isPlaying = false)),
            class: "hidden"
          }, null, 40, _hoisted_9)
        ]))
  ]))
}